import React from 'react';
import { useController } from 'react-hook-form';
import CustomInputField from 'components/shared/CustomInputField';
import './InputField.css';

function InputField({ name, label, placeholder, errors, setErrors, disabled }) {
  const {
    field: { value, onChange }
  } = useController({ name });

  return (
    <div className="Input_Wrapper" data-testid='Input_Wrapper'>
      <CustomInputField
        name={name}
        label={label}
        placeholder={placeholder}
        value={value}
        disabled={disabled}
        onChange={onChange}
        setErrors={setErrors}
        errorMessage={errors?.[name]}
      />
    </div>
  );
}

export default InputField;
